export default function DistintaBasePage() {
  return (
    <div className="p-8 text-center text-gray-400">
      <p className="text-lg">Distinta Base — in sviluppo</p>
    </div>
  )
}
